import { ExternalAccountingProviderType } from '../types/Invoicing';

export function isAccountingProviderType(
    providerName: string,
): providerName is ExternalAccountingProviderType {
    return providerName === 'xero' || providerName === 'quick_books';
}
